<script lang="ts" setup>
import { RouterView } from 'vue-router'
import { initToasts } from '@/composables/toast'
import { initConfirmations } from '@/composables/confirmation'
import Toast from '@/components/common/Toast.vue'
import ConfirmDialog from 'primevue/confirmdialog'
import { useUserStore } from '@/stores/user'
import { useMapCoordinateSelectionStore } from '@/stores/mapCoordinateSelection'

const userStore = useUserStore()
const mapCoordinateSelectionStore = useMapCoordinateSelectionStore()
userStore.getUserRoles()

initToasts()
initConfirmations()

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    mapCoordinateSelectionStore.prohibitSetCoordinates()
  }
})
</script>

<template>
  <Toast />
  <ConfirmDialog group="confirmation" />
  <RouterView />
</template>

<style lang="scss" scoped></style>
